// extracted by mini-css-extract-plugin
export default {"ProcessesPage":"ProcessesPage_ProcessesPage__VsyVp"};